import "../styles/Skills.css";

export default function Skills() {
  return (
    <section className="skills">
      <h2 className="skills__title">SKILLS</h2>
      <div className="skills-card">
        <div className="skills-card__skill">
          <img src="/JS.png" alt="JavaScript" />
          <p>JavaScript</p>
        </div>
        <div className="skills-card__skill">
          <img src="/React.png" alt="React" />
          <p>React</p>
        </div>
        <div className="skills-card__skill">
          <img src="/html5.png" alt="HTML5" />
          <p>HTML5</p>
        </div>
        <div className="skills-card__skill">
          <img src="/css.png" alt="CSS3" />
          <p>CSS3</p>
        </div>
        <div className="skills-card__skill">
          <img src="/node.png" alt="Node" />
          <p>Node</p>
        </div>
        <div className="skills-card__skill">
          <img src="/express.png" alt="Express" />
          <p>Express</p>
        </div>
        <div className="skills-card__skill">
          <img src="/pg.png" alt="PostgreSQL" />
          <p>PostgreSQL</p>
        </div>
        <div className="skills-card__skill">
          <img src="/restfulapi.png" alt="RESTful API" />
          <p>RESTful API</p>
        </div>
        <div className="skills-card__skill">
          <img src="/agile3.png" alt="Agile" />
          <p>Agile</p>
        </div>
        <div className="skills-card__skill">
          <img src="/git.png" alt="Git" />
          <p>Git</p>
        </div>
        <div className="skills-card__skill">
          <img src="/heroku.png" alt="Heroku" />
          <p>Heroku</p>
        </div>
        <div className="skills-card__skill">
          <img src="/bash.png" alt="Bash Shell" />
          <p>Bash</p>
        </div>
      </div>
    </section>
  );
}
